import { __rest } from '../../node_modules/tslib/tslib.es6.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import { forwardRef, useEffect } from 'react';
import { InternalLink, ExternalLink } from './link.style.js';
import { LinkIcon } from './shared.style.js';

const Link = forwardRef((props, ref) => {
    const { backgroundColor = 'primaryInverse', backgroundless, children, className = '', color = 'primary', fontSize = 500, fullWidth, hideIcon = false, href, margin, onClick, openInNewTab, size = 'medium', textAlign, to, type = 'standalone', whiteSpace } = props, rest = __rest(props, ["backgroundColor", "backgroundless", "children", "className", "color", "fontSize", "fullWidth", "hideIcon", "href", "margin", "onClick", "openInNewTab", "size", "textAlign", "to", "type", "whiteSpace"]);
    const standaloneProps = type === 'standalone'
        ? {
            fontSize,
            margin,
            textAlign,
            whiteSpace,
        }
        : {};
    const ctaProps = type === 'CTA'
        ? {
            backgroundColor,
            backgroundless,
            fullWidth,
            margin,
            size,
            whiteSpace,
        }
        : {};
    const sharedProps = Object.assign({ className,
        color,
        onClick,
        type }, rest);
    if (type === 'CTA' && backgroundless && color !== 'primaryInverse') {
        sharedProps.color = 'accent9';
    }
    // Ensure that the default CTA link with a background
    // does not have black text on a green background, which
    // is the default color arrangement for other link types.
    if (type === 'CTA' &&
        backgroundColor === 'primaryInverse' &&
        color === 'primary' &&
        !backgroundless) {
        sharedProps.color = 'primaryInverse';
    }
    const iconProps = {
        backgroundColor,
        backgroundless,
        color,
        icon: 'LinkArrow',
        margin: { left: '2px' },
        type,
    };
    useEffect(() => {
        if (to && href) {
            // eslint-disable-next-line no-console
            console.warn(`
        You are passing both an 'href' and a 'to' prop to the Link component.
        By default, when passed 'to', the Link will render a react-router <Link>.
        If you want an external link, only pass an 'href'.
      `);
        }
    }, [to, href]);
    const showIcon = !hideIcon && type !== 'inline';
    if (to) {
        return (jsxs(InternalLink, Object.assign({}, sharedProps, standaloneProps, ctaProps, { to: to, ref: ref, target: openInNewTab ? '_blank' : '_self' }, { children: [children, showIcon && jsx(LinkIcon, Object.assign({}, iconProps), void 0)] }), void 0));
    }
    else {
        return (jsxs(ExternalLink, Object.assign({}, sharedProps, standaloneProps, ctaProps, { href: href || '#', ref: ref, rel: "noopener noreferrer", target: openInNewTab === false ? '_self' : '_blank' }, { children: [children, showIcon && jsx(LinkIcon, Object.assign({}, iconProps), void 0)] }), void 0));
    }
});

export { Link };
